// Nguồn: ra-log-monitor-cms/source/src/constants/index.js — giữ NGUYÊN giá trị.
// Bổ sung các hằng hạ tầng mà template đích (@itz + hooks/routes) yêu cầu.

export const apiUrl = process.env.REACT_APP_API;

// ===== Hạ tầng repo đích =====
export const appName = 'iTZ-cms';

export const storageKeys = {
    USER_ACCESS_TOKEN: `${appName}-user-access-token`,
    USER_REFRESH_TOKEN: `${appName}-user-refresh-token`,
    USER_KIND: `${appName}-user-kind`,
};

export const accessRouteTypeEnum = {
    NOT_LOGIN: false,
    REQUIRE_LOGIN: true,
    BOTH: null,
};

export const defaultLocale = 'vi';
export const locales = ['en', 'vi'];
export const FILTER_PREFIX = `filter:`;

export const navigateTypeEnum = {
    PUSH: 'PUSH',
    POP: 'POP',
    REPLACE: 'REPLACE',
};

export const formSize = {
    small: '600px',
    normal: '700px',
    big: '1200px',
    editor: '1000px',
};

// ===== Nguồn: AppConstants =====
export const AppConstants = {
    apiRootUrl: process.env.REACT_APP_API,
    contentRootUrl: `${process.env.REACT_APP_API}/v1/file/download`,
    avatarRootUrl: `${process.env.REACT_APP_API}/v1/file/download`,
    mediaRootUrl: `${process.env.REACT_APP_API}`,
    langKey: 'vi',
};

// Nguồn: StorageKeys — khoá sessionStorage của bản cũ (KHÁC license: 'log-monitor-user-data')
export const StorageKeys = {
    userData: 'log-monitor-user-data',
};

export const dataStorage = 'sessionStorage';

// Nguồn: LayoutConfigs
export const LayoutConfigs = {
    NAV_WIDTH_EXPANDED: 280,
    NAV_WIDTH_COLLAPSED: 80,
};

export const UserTypes = {
    ADMIN: 1,
    CUSTOMER: 2,
    EMPLOYEE: 3,
};

// Nguồn giữ nguyên lỗi chính tả "Permisson"
export const GroupPermissonTypes = {
    ADMIN: 1,
    CUSTOMER: 2,
    EMPLOYEE: 3,
};

export const KIND_ADMIN = UserTypes.ADMIN;
export const KIND_CUSTOMER = UserTypes.CUSTOMER;

export const UploadFileTypes = {
    AVATAR: 'AVATAR',
    LOGO: 'LOGO',
    DOCUMENT: 'DOCUMENT',
};

export const ProvinceKinds = {
    province: { name: 'PROVINCE_KIND_PROVINCE', level: 1, text: 'Province' },
    district: { name: 'PROVINCE_KIND_DISTRICT', level: 2, text: 'District' },
    commune: { name: 'PROVINCE_KIND_COMMUNE', level: 3, text: 'Commune' },
};

// Nguồn giữ nguyên lỗi chính tả "Currentcy"
export const CurrentcyPositions = {
    FRONT: 0,
    BACK: 1,
};

export const LIMIT_IMAGE_SIZE = 512000;

// ===== Phân trang — nguồn: 50 (KHÁC mreport = 10, license = 100) =====
export const DEFAULT_TABLE_ITEM_SIZE = 50;
export const DEFAULT_TABLE_PAGE_START = 0;

// ===== Định dạng ngày giờ — nguồn =====
export const DATE_FORMAT_DISPLAY = 'DD/MM/YYYY';
export const DATE_FORMAT_VALUE = 'DD/MM/YYYY';
export const TIME_FORMAT_DISPLAY = 'HH:mm';
// ⚠️ nguồn dùng dấu '/', KHÁC license dùng dấu '.'
export const DEFAULT_TIME_FORMAT_DISPLAY = 'DD/MM/YYYY HH:mm:ss';
export const DEFAULT_FORMAT = 'DD/MM/YYYY HH:mm:ss';

// Hạ tầng đích (hooks/useSettingUnit) yêu cầu
export const DATE_FORMAT_BASIC = 'dd.MM.yyyy';
export const DATE_FORMAT_BASIC_FIX = 'DD.MM.YYYY';
export const DEFAULT_FORMAT_BASIC = 'dd.MM.yyyy HH:mm:ss';
export const DEFAULT_FORMAT_BASIC_FIX = 'DD.MM.YYYY HH:mm:ss';

// ===== Trạng thái — nguồn =====
export const STATUS_PENDING = 0;
export const STATUS_ACTIVE = 1;
export const STATUS_LOCK = -1;
export const STATUS_DELETE = -2;
export const STATUS_INACTIVE = STATUS_LOCK;

export const commonStatus = {
    PENDING: STATUS_PENDING,
    ACTIVE: STATUS_ACTIVE,
    INACTIVE: STATUS_LOCK,
    DELETE: STATUS_DELETE,
};

export const commonStatusColor = {
    [STATUS_PENDING]: 'warning',
    [STATUS_ACTIVE]: 'green',
    [STATUS_LOCK]: 'red',
    [STATUS_DELETE]: 'red',
};
